import React from 'react';

const ShareWithUserIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.33308 8.22232C9.05133 8.22232 10.4442 6.82941 10.4442 
        5.11116C10.4442 3.39291 9.05133 2 7.33308 2C5.61483 2 4.22192 3.39291 
        4.22192 5.11116C4.22192 6.82941 5.61483 8.22232 7.33308 8.22232Z" stroke="#595959" 
        stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.25487 17.9999H2V16.2221C2 14.8076 2.56191 13.4511 3.56212 12.4509C4.37662 
        11.6363 5.42747 11.1125 6.55346 10.946" stroke="#595959" stroke-width="1.25" 
        stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.0346 10.5901C15.0346 10.9833 15.1908 11.3605 15.4689 11.6385C15.7469 
        11.9166 16.1241 12.0728 16.5173 12.0728C16.9105 12.0728 17.2877 11.9166 17.5657 
        11.6385C17.8438 11.3605 18 10.9833 18 10.5901C18 10.1969 17.8438 9.81975 17.5657 
        9.54169C17.2877 9.26363 16.9105 9.10742 16.5173 9.10742C16.1241 9.10742 15.7469 
        9.26363 15.4689 9.54169C15.1908 9.81975 15.0346 10.1969 15.0346 10.5901Z" stroke="#595959" 
        stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.0346 16.5174C15.0346 16.9106 15.1908 17.2877 15.4689 17.5658C15.7469 
        17.8438 16.1241 18 16.5173 18C16.9105 18 17.2877 17.8438 17.5657 17.5658C17.8438 
        17.2877 18 16.9106 18 16.5174C18 16.1241 17.8438 15.747 17.5657 15.4689C17.2877 
        15.1909 16.9105 15.0347 16.5173 15.0347C16.1241 15.0347 15.7469 15.1909 15.4689 
        15.4689C15.1908 15.747 15.0346 16.1241 15.0346 16.5174Z" stroke="#595959" stroke-width="1.25" 
        stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.10638 13.5537C9.10638 13.947 9.2626 14.3241 9.54065 14.6022C9.81871 
        14.8802 10.1958 15.0364 10.5891 15.0364C10.9823 15.0364 11.3594 14.8802 11.6375 
        14.6022C11.9156 14.3241 12.0718 13.947 12.0718 13.5537C12.0718 13.1605 11.9156 
        12.7834 11.6375 12.5053C11.3594 12.2273 10.9823 12.071 10.5891 12.071C10.1958 
        12.071 9.81871 12.2273 9.54065 12.5053C9.2626 12.7834 9.10638 13.1605 9.10638 13.5537Z" 
        stroke="#595959" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.071 12.9613L15.0354 11.7756" stroke="#595959" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.071 14.1465L15.0354 15.3322" stroke="#595959" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
};

export default ShareWithUserIcon;
